export default __webpack_public_path__ + "static/media/JSE_Forest Birds - 30s sample.80ec0edd.mp3";